export default __webpack_public_path__ + "static/media/client-07.df8345b1.webp";